
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { updateSelectedParameters } from "../../../../utils/ResponseConver";
import {  AirConditioning } from "../components/AirConditioning";

export const AirCompressorComList = () => {
  const { eng_log_basic_id } = useParams();
  const [auxiliary_List, set_Auxiliary_List] = useState("");
  const [loader, set_loader] = useState(false);  
  const AUXILARY_MACHINARY_LIST_LOGBOOK_API = async (id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id); 
      FORM_DATA.append("ship_id", id);
  
      const res = await post(ApiURL.list_machinary_details_com, FORM_DATA);
  
      if (res?.status === true) {
        const updatedDataWithFormattedParams = res.response_data.map((item) => ({
          ...item,
          selected_parameters: updateSelectedParameters(item.selected_parameters),
        }));
        set_Auxiliary_List(updatedDataWithFormattedParams);
      }
    } catch (error) {
      console.error("Error updating logbook:", error);
    }
  };
  
  useEffect(() => {
    const ship_id = JSON.parse(localStorage.getItem("ship_id"));
    AUXILARY_MACHINARY_LIST_LOGBOOK_API(ship_id);
  }, []);

  return (
    <>
    <div className="white-container">
        <>
            {auxiliary_List?.length > 0
              ? auxiliary_List
                  .filter((item) => item?.machine_id === 2)
                  .map((_items) => (
                    <AirConditioning
                      key={_items.id}
                      eng_log_basic_id={eng_log_basic_id}
                      _items={_items}
                    />
                  ))
              : "No data available"}
          </>
      </div>
    </>
  );
};
